import axios from '../axios'

// 验证登录信息
export const checkAuthor = (params) => {
  //console.log("checkAuthor...", params);
  return axios({
      url: '/login/checkAuthor',
      method: 'post',
      params
  })
}

export const loginout = () => {
  console.log("loginout api");
  return axios({
      url: '/login/out',
      method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/http/modules/login.js